import React from 'react';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import Confirm from 'react-confirm-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';

import Link from '../../../../components/Link';
import CommonTable from '../../../CommonTable/CommonTable';
import CustomPagination from '../../../CustomPagination';

import { deleteWhyHostReview } from '../../../../actions/siteadmin/WhyHostReview/deleteWhyHostReview';
import { debounce } from '../../../../helpers/debounce';
import messages from '../../../../locale/messages';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import s from './AdminReviewsManagement.css';
import bt from '../../../../components/commonStyle.css';


function AdminReviewsManagement(props) {
  const { deleteWhyHostReview, setStateVariable, currentPage, reviewsManagement: { refetch, getWhyHostAllReviews, loading } } = props;

  const { formatMessage } = useIntl();

  const paginationData = (currentPage) => {
    let variables = { currentPage };
    refetch(variables);
  }

  const handleSearchChange = debounce((searchList) => {
    let variables = {
      currentPage: 1,
      searchList,
    };
    setStateVariable(variables);
    refetch(variables);
  }, 250)

  const deleteReview = async ({ reviewId }) => {
    const { demoRestriction } = props;
    let variables = { currentPage: currentPage > 1 && getWhyHostAllReviews?.results?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await deleteWhyHostReview({ reviewId });
    await setStateVariable(variables);
    await refetch(variables);
  }

  const thead = () => {
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.userNameLabel) },
      { data: formatMessage(messages.reviewContentLabel) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }

  const tbody = () => {
    return getWhyHostAllReviews?.results?.map((review, key) => {
      return {
        id: key,
        data: [
          { data: review?.id },
          { data: review?.userName },
          { data: review?.reviewContent },
          {
            data: <Link to={"/siteadmin/whyHost/review/edit/" + review?.id}>
              <FormattedMessage {...messages.editLabel} />
            </Link>
          },
          {
            data: <div>
              <Confirm
                onConfirm={() => deleteReview({ reviewId: review?.id })}
                body={formatMessage(messages.areYouSureDeleteWishList)}
                confirmText={formatMessage(messages.confirmDelete)}
                cancelText={formatMessage(messages.cancel)}
                title={formatMessage(messages.deleteReviewLabel)}
              >
                <a href="javascript:void(0)">
                  <FormattedMessage {...messages.delete} />
                </a>
              </Confirm>
            </div>
          }
        ]
      }
    })
  }

  return (
    <div>
      <CommonTable
        title={formatMessage(messages.whyBecomeHostBlock5)}
        thead={thead}
        tbody={() => tbody()}
        isSearch
        handleSearch={(e) => handleSearchChange(e?.target?.value)}
        isLink
        linkURL={'/siteadmin/whyHost/review/add'}
        linkLabel={formatMessage(messages.addNewLabel)}
        loading={loading}
      />
      {
        getWhyHostAllReviews?.results?.length > 0
        && <div>
          <CustomPagination
            total={getWhyHostAllReviews.count}
            currentPage={currentPage}
            defaultCurrent={1}
            defaultPageSize={10}
            change={paginationData}
            paginationLabel={formatMessage(messages.reviews)}
            isScroll
          />
        </div>
      }
    </div >
  );
}

const mapState = (state) => ({
});

const mapDispatch = {
  deleteWhyHostReview,
  demoRestriction
};

export default compose(injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
)(AdminReviewsManagement);